import React from 'react'
import styled from 'styled-components'
import { Emoji } from '@mote/presentation'
import { Block, BlockGroup, Button, Carousel, H1, H2, H3, H4 } from '@mote/ui'
import { Content, DefaultLayout } from '../layouts'

export const AmplifierScreen = () => {
  return (
    <DefaultLayout>
      <Content>
        <Block gap={30}>
          <H2>Learn and Share: The Mote Amplifier Package</H2>

          <Carousel>
            <img
              className='d-block w-100'
              src='images/photos/amplifier-1.png'
              alt='Amplifier Package'
            />

            <img
              className='d-block w-100'
              src='images/photos/amplifier-2.png'
              alt='Amplifier Package'
            />

            <img
              className='d-block w-100'
              src='images/photos/amplifier-3.png'
              alt='Amplifier Package'
            />

            <img
              className='d-block w-100'
              src='images/photos/amplifier-4.png'
              alt='Amplifier Package'
            />

            <img
              className='d-block w-100'
              src='images/photos/amplifier-5.png'
              alt='Amplifier Package'
            />
          </Carousel>
        </Block>

        <BlockGroup gap={30}>
          <BlockGroup maxWidth={750} margin='50px auto 0 auto' gap={20}>
            <Block gap={20}>
              <H1 alignment='center'>
                Do you want to help others to discover the joy of Mote?
              </H1>
              <H3 alignment='center'>If so, you are amazing! </H3>
              <H3 alignment='center'>
                <em>And</em> you're in the right place - welcome to the Mote
                Amplifier Package! <Emoji>📢</Emoji>
              </H3>
            </Block>

            <Block gap={20}>
              <H3>What is Mote Amplifier?</H3>
              <UL>
                <li>
                  Mote Amplifier is our program for supporting anyone looking to
                  spread the word about Mote
                </li>
                <li>
                  Once you've signed up, we'll send you a link to an exclusive
                  PD deck developed with the wonderful{' '}
                  <a href='https://slidesmania.com'>SlidesMania</a>
                </li>
                <li>
                  We're standing by to help you deliver a great learning
                  experience for other educators. We may also be able send you
                  some cool swag...<Emoji>😉</Emoji>
                </li>
              </UL>

              <H3>Getting started with Amplifier</H3>

              <UL>
                <li className='lead'>
                  Read about the different session formats, then click to 'Get
                  Started'!
                </li>
                <li className='lead'>
                  Tell us a bit about yourself (we already know you’re awesome!)
                </li>
                <li className='lead'>
                  Tell us a bit more about the session you're planning
                </li>
                <li className='lead'>
                  You'll receive a link to the Mote Amplifier Package - created
                  in collaboration with{' '}
                  <a
                    className='mote-boiler-link'
                    href='https://slidesmania.com/'
                  >
                    SlidesMania
                  </a>
                  !
                </li>
              </UL>
            </Block>
          </BlockGroup>

          <Block gap={20}>
            <H3 alignment='center'>Amplifier session formats</H3>

            <Block layout='horizontal' gap={20}>
              <Card>
                <div className='card-header'>
                  <H4>EdCamp/Conference</H4>
                </div>
                <div className='card-body'>
                  <p>These are so much fun - even more so with Mote 🚀 </p>
                  <p>
                    The Mote Amplifier Package gives you a great headstart!{' '}
                  </p>
                  <p>
                    {' '}
                    We’ll do our best to support you with super swag and prizes!
                    🏆
                  </p>
                </div>
              </Card>

              <Card>
                <div className='card-header'>
                  <H4>PD Sessions</H4>
                </div>
                <div className='card-body'>
                  <p>
                    The most powerful voice is that of a trusted coworker.💜{' '}
                  </p>
                  <p>Ready to become an advocate of Mote in your community? </p>
                  <p>
                    Use the Amplifier Package template to share Mote - step by
                    simple step
                  </p>
                </div>
              </Card>

              <Card>
                <div className='card-header'>
                  <H4>Self-Paced Course</H4>
                </div>
                <div className='card-body'>
                  <p>Asynchronous learning is a thing - that’s for sure! ✅ </p>
                  <p>The Amplifier Package is easily shared with your team</p>
                  <p>
                    Your colleagues can learn about all of Mote's features at
                    their own pace
                  </p>
                </div>
              </Card>
            </Block>

            <Block gap={15} align='center' margin='10px 0 20px 0'>
              <H2>Ready to Amplify?</H2>
              <Button
                onClick={_ =>
                  (window.location.href =
                    'https://share.hsforms.com/1-iO89ukaSvWtSkvALVrQ4Q4w7sl')
                }
                text='Sign up'
              />
              <Button
                text='Descargar Amplifier en español'
                href='https://docs.google.com/presentation/d/1PLp_pFwXIc85TR-9RS1ek66kAOFVmiSlTj26cH2pBDQ/template/preview'
                tag='a'
                variant='link'
              />
            </Block>
          </Block>
        </BlockGroup>
      </Content>
    </DefaultLayout>
  )
}

const UL = styled.ul`
  list-style-type: disc;

  li {
    font-size: 21px;
  }

  a {
    color: #ac0ae8;
    text-decoration: underline;
  }
`

const Card = styled.div`
  border: 4px solid #006aff;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  text-align: center;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: 0.5rem;
  width: 330px;

  .card-header {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    margin-bottom: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);

    h4 {
      margin-bottom: 1rem;
      font-weight: 400;
    }
  }
  .card-body {
    padding: 1.25rem;
    font-size: 16px;
    line-height: 1.5;

    p:not(:last-of-type) {
      margin-bottom: 10px;
    }
  }
`
